
import AppLayout from '../../components/feature/AppLayout';
import SettingsSection from '../home/components/SettingsSection';

export default function ConfiguracoesPage() {
  return (
    <AppLayout>
      <SettingsSection />
    </AppLayout>
  );
}

